import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
// import dayjs from "dayjs";
import { useSnackbar } from "notistack";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";

import { updateStatusInProgress } from "src/api/purchaseOrder";

import font from "src/styles/font";
import { Black, Primary } from "src/styles/color";
import { checkNotEmpty } from "src/common";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import PaymentComponent from "src/modules/order/purchase-order/modal/component/PaymentComponent";

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    top: 16px;
    right: 16px;
    color: ${Black};
  }
`;

const StyledDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    padding: 24,
    paddingTop: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 640,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const PaymentDialog = ({ orderDetail, onClose, onSuccess, setIsLoading }) => {
  const { enqueueSnackbar } = useSnackbar();

  const defaultData = {
    paySlipImage: "",
    status: "",
    paymentType: "",
    slipDate: "",
  };
  const [updateOrder, setUpdateOrder] = useState(defaultData);

  // const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!orderDetail) return;

    setUpdateOrder({
      ...defaultData,
      status: orderDetail?.statusPayment?.status,
      paymentType: orderDetail?.statusPayment?.paymentType,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail]);

  const isFormValid = [
    "status",
    "paymentType",
    "paySlipImage",
    "slipDate",
  ].every((required) => {
    let objVal = updateOrder[required];
    return required === "slipDate" || required === "slipOtherDate"
      ? objVal !== ""
      : checkNotEmpty(objVal);
  });

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const updateParams = {
        ...updateOrder,
      };

      await updateStatusInProgress(orderDetail?._id, updateParams);
      enqueueSnackbar(`Update Payment Success!`, {
        variant: "success",
      });
      await onSuccess();
    } catch (err) {
      console.error("err:", err.response);
      enqueueSnackbar(err.response.data.message, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogTitle
        sx={{
          p: {
            sm: 3,
            xs: 2,
          },
          display: "flex",
          flexDirection: {
            sm: "row",
            xs: "column",
          },
          alignItems: {
            sm: "center",
            xs: "flex-start",
          },
          gap: 1,
          fontSize: {
            sm: font.size.lg,
            xs: font.size.md,
          },
          fontWeight: 600,
          span: {
            color: Primary,
            fontWeight: 400,
          },
        }}
      >
        การชำระเงิน
        {!isFormValid ? <span>โปรดแนบหลักฐานการชำระเงิน</span> : null}
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
      </DialogTitle>

      <DialogContent>
        <PaymentComponent
          updateOrder={updateOrder}
          setUpdateOrder={setUpdateOrder}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => onClose()}
          fullWidth
          sx={{ maxWidth: 180 }}
        >
          ยกเลิก
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit()}
          disabled={!isFormValid}
          fullWidth
          sx={{ maxWidth: 180 }}
          type="submit"
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default PaymentDialog;
